/**
 * Control Center base-path prefix — SINGLE SOURCE for the URL prefix the app is
 * served under, derived from the build's Vite `base` (app.justtextava.com migration,
 * 2026-07-16).
 *
 * Vite bakes `base` into `import.meta.env.BASE_URL` at build time:
 *   - Firebase build  (base '/control-center/')  → CC = '/control-center'
 *   - app.justtextava build (base '/')            → CC = ''
 *
 * The router basename stays '/', because the standalone mobile pages
 * (`/approve/:token`, `/profile-question/:token`) live at ROOT on BOTH origins
 * (they're deep-linked from SMS) — so a router-wide basename can't move the app.
 * Instead every *main-app* path is prefixed with `ccPath()`, and the mobile
 * routes stay literal at root.
 *
 * Use `ccPath('/dashboard')` everywhere a main-app absolute path is needed —
 * router `<Navigate>`/`<Link to>`/`navigate()` AND full-page `<a href>` — so one
 * build serves both origins correctly with no per-site literals.
 */

// BASE_URL is always slash-terminated ('/' or '/control-center/'). Strip the
// trailing slash so ccPath('/x') === '/control-center/x' (not a double slash),
// and so CC is '' (falsy) on the root build.
export const CC = import.meta.env.BASE_URL.replace(/\/$/, '')

/** Absolute path to a main-app route, prefixed with the deploy base. */
export function ccPath(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${CC}${p}`
}
